<template>
    <div class="JoinResult">
        <!-- s: contents -->
        <div class="contents-area-noscroll">
            <h2 class="header-title pdd-top-40  pdd-btm-30">회원가입완료!</h2>
            <div>
                <img src="@/assets/images/join_result.png" width="100%" />
            </div>
            <p class="join-result-msg pdd-top-30 pdd-btm-40">
                <strong>
                    {{ $route.params.data.strUserId }}
                    ( {{ $route.params.data.strEmpName }} )
                </strong> 님<br/>
                모비고 회원가입을 환영합니다.
            </p>
            <router-link class="btn-big btn-bule"
                         tag="button"
                         to="/login">
                로그인
            </router-link>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
    export default {
        name: 'JoinResult',
        data() {
            return {
            }
        },
        // $el 생성전
        created(){
        },
        // $el 생성후
        mounted() {
            window.callbackBackKey = this.callbackBackKey;
        },
        methods: {
            // APP 뒤로가기
            callbackBackKey(){
                this.$router.push('/login').catch(this.routerCatchError)
            },
        }
    }
</script>

<style scoped>
    .JoinResult {height: 100%;background: #f2faff; }
    .header-title {font-size: 24px;text-align: center;}
    .join-result-msg{text-align: center;font-size: 16px;font-weight: 300;}
</style>
